export default __webpack_public_path__ + "static/media/referral.85e1802e.svg";